import { render, staticRenderFns } from "./cloabjj.vue?vue&type=template&id=5ddb58ad&scoped=true&"
import script from "./cloabjj.vue?vue&type=script&lang=js&"
export * from "./cloabjj.vue?vue&type=script&lang=js&"
import style0 from "./cloabjj.vue?vue&type=style&index=0&id=5ddb58ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb58ad",
  null
  
)

export default component.exports